import { InjectedConnector } from "@web3-react/injected-connector";

export const injected = new InjectedConnector({
  supportedChainIds: [1, 4, 1337, 11155111, 150, 61, 97,98],
});
